module.exports = __webpack_public_path__ + "b03774ecdf88ef7b4002472d7c9f0e4d.svg";